module.exports = __webpack_public_path__ + "img/mw.66944c9f.svg";